
import { nonEmpty } from '@bkwld/cloak/services/helpers'
import { mountOnBody } from 'library/services/helpers'
import VideoModal from 'library/components/globals/modals/video'

export default

	props:

		# URL to link to
		to: String

		# Size of the button
		size:
			type: String
			validator: (val) -> val in ['small', 'x-small']

		# If a <button>, what type is it
		type:
			type: String
			default: 'button'
			validator: (val) -> val in ['button', 'submit', 'reset']

		theme:
			type: String
			default: 'solid'
			validator: (val) -> val in ['solid', 'outline', 'text', 'inverted']

		videoModal:
			type: Boolean
			default: false

		noText:
			type: Boolean
			default: false

		# States
		loading: Boolean
		disabled: Boolean

	computed:

		# Root classes
		classes: -> [
			"size-#{@size}" if @size
			"theme-#{@theme}" if @theme
			'no-text' if @noText
			loading: @loading
		]

		# States that should supress clicks
		nonInteractive: -> @disabled or @loading

		# is a video?
		isVideoUrl: -> !!@to?.match /\.mp4$/

	methods:

		onClick: (e) ->

			# first, mount video if selected
			if @videoModal
				e.preventDefault()
				@mountVideoModal()

			# Prevent clicking if non-interactive
			if @nonInteractive
			then e.preventDefault()
			else @$emit 'click'

		mountVideoModal: ->
			await mountOnBody VideoModal,
				parent: this
				propsData: { videoUrl: @to }

	# Conditionally change the root button type
	render: (create) ->

		# Make the shared data object
		data =
			class: ['btn', ...@classes]
			domProps: disabled: @nonInteractive
			on: click: @onClick

		# The contents of the button
		children = [
			create 'span', class: 'shape'
			create 'span', class: 'slot', nonEmpty [
				@$slots.default
				if @loading then create 'span', class: 'icon-spinner'
			]
			create 'span', class: 'icon-video' if @videoModal
		]

		# Render a smart-link
		if @to && !@isVideoUrl
			create 'smart-link', {
				...data
				attrs: {
					...data.attrs
					role: 'button'
				}
				props: { @to }
			}, children

		# Render an html button
		else
			create 'button', {
				...data
				domProps: {
					...data.domProps
					@type
				}
			}, children

